import { makeStyles } from '../../../styles';
export const useWizardNavEntryStyles = makeStyles((theme) => ({
    container: {
        all: 'unset',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(1),
        cursor: 'pointer',
        transition: 'text-shadow .2s',
        '&:hover': {
            textShadow: `0 0 0 ${theme.colors.gray[800]}`,
        },
        '&:disabled': {
            cursor: 'default',
            '&:hover': {
                textShadow: 'none',
            },
        },
    },
    text: {
        fontFamily: "'Source Sans Pro', sans-serif, sans-serif",
        display: 'inline-flex',
        padding: '7px 15px',
        fontSize: '16px',
        borderRadius: theme.shape.borderRadius,
        flex: '1',
    },
    inactive: {
        fontWeight: theme.typography.fontWeightLight,
        backgroundColor: 'inherit',
        color: theme.colors.gray[800],
    },
    active: {
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: theme.colors.gray[100],
        color: theme.colors.primary.main,
    },
}));
//# sourceMappingURL=WizardNavEntry.styles.js.map